import {
  Outlet,
  createRootRouteWithContext,
  HeadContent,
  useRouterState,
} from "@tanstack/react-router";
import { Box, Container } from "@mui/material";
import { Suspense } from "react";
import { RouterContext } from "../types/routerContext.ts";
import Navigation from "../components/Navigation.tsx";
import { useOktaAuth } from "@okta/okta-react";

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <>
      <HeadContent />
      <RootComponent />
    </>
  ),
  head: () => ({
    meta: [
      {
        title: "Product Administration",
      },
      {
        name: "description",
        content: "Product Administration - AAP - Quality",
      },
    ],
  }),
});

function RootComponent() {
  const { authState } = useOktaAuth();
  const routerState = useRouterState();
  
  // Hide navigation on login, callback, and no-permission pages, or when not authenticated
  const publicRoutes = ['/login', '/callback', '/no-permission'];
  const shouldShowNavigation = 
    authState?.isAuthenticated && 
    !publicRoutes.includes(routerState.location.pathname);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      {shouldShowNavigation && <Navigation />}
      <Container
        component={"main"}
        maxWidth={false}
        sx={{
          mt: shouldShowNavigation ? 12 : 0,
          maxWidth: "1800px !important",
        }}
      >
        <Suspense fallback={<Box sx={{ mt: 12 }} />}>
          <Outlet />
        </Suspense>
      </Container>
    </Box>
  );
}
